import { certificadoJs, certificadoReact } from '../img';


export const dataEducacion = [
    {
        id: 1,
        titulo: 'Bootcamp Full Stack Web Developer, NEOLAND',
        ubicación: 'Barcelona',
        fecha: 'Sep - Dic 3022',
        credencial: 'https://www.credential.net/a1131583-c424-4ce7-bfe8-d6573a4487f3#gs.o4jhkd'
    },
    {
        id: 2,
        titulo: 'JavaScript Moderno: Guía para dominar el lenguaje, Udemy',
        temario: 'Bases de JavaScript - Tipos de datos - Objetos - Operadores - Ciclos - ESNext - Clases - Propiedades privadas - Node - Npm - Instalación de paquetes en proyectos de JavaScript - Promesas - Callbacks - CRUD - Modals manuales - Carga de archivos - Fetch - Funciones generadoras - Vite - Mappers - JSDocs y documentación de funciones - VSCode con tipos de datos en JavaScript - Manipulación del DOM - Archivado Webpack',
        ubicación: 'Barcelona',
        fecha: '17 de Enero de 2023',
        credencial: certificadoJs
    },
    {
        id: 3,
        titulo: 'React: De cero a experto ( Hooks y MERN ), Udemy',
        temario: 'Hooks y Hooks personalizados - Context API - Redux - MERN (Mongo + Express + React + Node) - Router - Bootstrap - Mongoose - JWT - Google Sign-in - Autenticación personalizada - Unit Test - Despliegues a producción - Enzyme - Jest - React Testing Library - Mocks - Animaciones en componentes - History - QueryStrings - Heroku y Heroku Logs - Git y Github - Redux DevTools - React DevTools',
        ubicación: 'Barcelona',
        fecha: '23 de Mayo de 2023',
        credencial: certificadoReact
    },
    {
        id: 4,
        titulo: 'Analista en Administración Bancaria y Comercio Exterior',
        ubicación: 'Rosario, Santa Fe, Argentina',
        fecha: '2010-2013',
        instituto: 'Instituto Superior particular Nro. 4039',

    },
]